export default {
  // 生成UUID
  uuid: function () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  },

  /**
   * 校验字符串是否是空值或者undefined
   */
  isNull: function (val) {
    if (val === '' || val === undefined) {
      return null
    } else {
      return val
    }
  },
  /**
   * 产生随机数函数
   */
  rndNum: function (n) {
    var rnd = ''
    for (var i = 0; i < n; i++) { rnd += Math.floor(Math.random() * 10) }
    return parseInt(rnd)
  },
  /**
   * 判断数组中对象是否是空值
   */
  isEmpty: function (obj) {
    let empty = true
    for (const key in obj) {
      if (obj[key]) {
        empty = false
        break
      }
    }
    return empty
  },
  /**
   * 照片下载
   * 下载图片地址和图片名
   */
  downloadIamge: function (imgsrc, name) {
    var image = new Image()
    // 解决跨域 Canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous')
    image.onload = function () {
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)
      var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据

      var a = document.createElement('a') // 生成一个a元素
      var event = new MouseEvent('click') // 创建一个单击事件
      a.download = name || 'photo' // 设置图片名称
      a.href = url // 将生成的URL设置为a.href属性
      a.dispatchEvent(event) // 触发a的单击事件
    }
    image.src = imgsrc
  },
  /**
   * 加法运算，避免数据相加小数点后产生多位数和计算精度损失。
   *
   * @param num1加数1 | num2加数2
   */
   numAdd:function(num1, num2) {
  const s1 = num1.toString();
  const s2 = num2.toString();

  // 获取小数位数
  const d1 = (s1.split('.')[1] || '').length;
  const d2 = (s2.split('.')[1] || '').length;

  // 取最大精度
  const maxD = Math.max(d1, d2);
  const scale = Math.pow(10, maxD);

  // 将两个数都转为整数（通过字符串拼接避免浮点误差）
  const n1 = parseInt(s1.replace('.', '') + '0'.repeat(maxD - d1), 10);
  const n2 = parseInt(s2.replace('.', '') + '0'.repeat(maxD - d2), 10);

  return (n1 + n2) / scale;
},
/**
 * 减法运算，避免数据相减小数点后产生多位数和计算精度损失。
 *
 * @param num1被减数  |  num2减数
 */
numSub: function (num1, num2, fixed = null) {
  const s1 = num1.toString();
  const s2 = num2.toString();

  const d1 = (s1.split('.')[1] || '').length;
  const d2 = (s2.split('.')[1] || '').length;
  const maxD = Math.max(d1, d2);

  const n1 = parseInt(s1.replace('.', '') + '0'.repeat(maxD - d1), 10);
  const n2 = parseInt(s2.replace('.', '') + '0'.repeat(maxD - d2), 10);

  const result = (n1 - n2) / Math.pow(10, maxD);

  if (fixed !== null) {
    return result.toFixed(fixed); // 返回字符串
  }
  return result; // 返回 number
},
/**
 * 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失。
 *
 * @param num1被乘数 | num2乘数
 */
numMulti: function (num1, num2) {
  var baseNum = 0
  try {
    baseNum += num1.toString().split('.')[1].length
  } catch (e) {
  }
  try {
    baseNum += num2.toString().split('.')[1].length
  } catch (e) {
  }
  return Number(num1.toString().replace('.', '')) * Number(num2.toString().replace('.', '')) / Math.pow(10, baseNum)
},
/**
 * 除法运算，避免数据相除小数点后产生多位数和计算精度损失。
 *
 * @param num1被除数 | num2除数
 */
numDiv: function (num1, num2) {
  var baseNum1 = 0; var baseNum2 = 0
  console.log(num1, num2, "num1, num2")
  var baseNum3, baseNum4
  try {
    baseNum1 = num1.toString().split('.')[1].length
  } catch (e) {
    baseNum1 = 0
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length
  } catch (e) {
    baseNum2 = 0
  }
  Math.baseNum3 = Number(num1.toString().replace('.', ''))
  Math.baseNum4 = Number(num2.toString().replace('.', ''))
  console.log((Math.baseNum3 / Math.baseNum4) * Math.pow(10, Math.baseNum2 - Math.baseNum1))
  return (Math.baseNum3 / Math.baseNum4) * Math.pow(10, Math.baseNum2 - Math.baseNum1)
},
/**
 * 输入数字计算百分比
 */
percentage: function (num, total) {
  if (num === 0 || total === 0) {
    return 0
  }
  return ((num / total * 10000) / 100).toFixed(2)// 小数点后两位百分比
},
/**
 * 输入百分比计算数字
 */
number: function (num, total) {
  if (num === 0 || total === 0) {
    return 0
  }
  return (num * total / 100).toFixed(2)// 小数点后两位数字
},
// 去除空字符
objRemoveEmptyItem: function (obj) {
  const result = {}
  for (const key in obj) {
    if (obj[key] !== '' && obj[key] != null && obj[key] !== '') {
      result[key] = obj[key]
    }
  }
  return result
},
// 判断导航权限
judgePermissions: function (leftNav, permissions) { // 参数1：导航数组；参数2：权限数组
  var newLeftNav = leftNav.filter(item1 => {
    if (permissions.includes(item1.permissions)) { // 如果权限数组中存在一级菜单的权限
      if (item1.children.length) { // 如果有二级菜单
        item1.children = item1.children.filter(item2 => {
          if (permissions.includes(item2.permissions)) { // 如果权限数组中存在二级菜单的权限
            return item2 // 返回二级菜单存在的权限数据
          }
        })
      }
      if (!item1.url && !item1.children.length) { // 如果一级菜单的 url 地址为空并且是空数组
      } else {
        return item1 // 否则返回一级菜单存在的权限数据
      }
    }
  })
  return newLeftNav
},
// 处理千位符
toThousandsNoZero: function (num) {
  return num ? ((isNaN(parseFloat(num.toString().replace(/,/g, ''))) ? 1 : parseFloat(num.toString().replace(/,/g, '')))).toFixed(2).toString().replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
    return $1 + ','
  }) : ''
},
// 去除千位符
delThousandsNum(num) {
  if ((num + '').trim() === '') {
    return ''
  }
  if (typeof num === 'string' && num.indexOf(',') > -1) {
    num = num.replace(/,/gi, '')
    return num
  } else {
    return num
  }
},

// 金额转大写
capAmount: function (n) {
  var unit = '仟佰拾亿仟佰拾万仟佰拾元角分'
  var str = ''
  n += '00'
  var a = n.indexOf('-')
  var indexpoint = n.indexOf('.') // 如果是小数，截取小数点前面的位数
  if (a !== -1) {
    n = n.substring(1)
    if (indexpoint >= 0) {
      n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2) // 若为小数，截取需要使用的unit单位
    }
    unit = unit.substr(unit.length - n.length) // 若为整数，截取需要使用的unit单位
    for (let i = 0; i < n.length; i++) {
      str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i) // 遍历转化为大写的数字
    }
    return '负数' + str.replace(/零(仟|佰|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|元)/g, '$1').replace(/(亿)万/g, '$1').replace(/^元零?|零分/g, '').replace(/元$/g, '元整').replace(/角$/g, '角整') // 替换掉数字里面的零字符，得到结果
  } else {
    if (indexpoint >= 0) {
      n = n.substring(0, indexpoint) + n.substr(indexpoint + 1, 2) // 若为小数，截取需要使用的unit单位
    }
    unit = unit.substr(unit.length - n.length) // 若为整数，截取需要使用的unit单位
    for (let i = 0; i < n.length; i++) {
      str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i) // 遍历转化为大写的数字
    }
    return str.replace(/零(仟|佰|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|元)/g, '$1').replace(/(亿)万/g, '$1').replace(/^元零?|零分/g, '').replace(/元$/g, '元整').replace(/角$/g, '角整') // 替换掉数字里面的零字符，得到结果
  }
},
// 下载文件
downloadFiles: function (blobUrl, name) {
  const a = document.createElement('a')
  a.style.display = 'none'
  a.download = name
  a.href = blobUrl
  a.click()
},
// 计算两个日期之间的天数
daysDistance: function (dateString1, dateString2) {
  var startDate = Date.parse(dateString1)
  var endDate = Date.parse(dateString2)
  var days = Math.ceil((endDate - startDate) / (1 * 24 * 60 * 60 * 1000))
  // alert(days);
  return days
},
// 计算两个日期之间的天数(向下取整，自己加小数)
daysDistance2: function (dateString1, dateString2) {
  var startDate = Date.parse(dateString1)
  var endDate = Date.parse(dateString2)
  var days = Math.floor((endDate - startDate) / (1 * 24 * 60 * 60 * 1000))
  // alert(days);
  return days
},
// 当前日
doHandleDate() {
  const myDate = new Date()
  const myDate1 = myDate.getDate()
  // const tYear = myDate.getFullYear()
  // const tMonth = myDate.getMonth()
  // let m = tMonth + 1
  // if (m.toString().length === 1) {
  //   m = '0' + m
  // }
  return myDate1
},
// 当前年
doHandleYear() {
  const myDate = new Date()
  const tYear = myDate.getFullYear()
  return tYear
},
// 当前月
doHandleMonth() {
  const myDate = new Date()
  const tMonth = myDate.getMonth()
  const m = tMonth + 1
  // if (m.toString().length === 1) {
  //   m = '0' + m
  // }
  return m
},
// 传入年份和月份 获取该年对应月份的天数
getMonthDays(year, month) {
  var thisDate = new Date(year, month, 0) // 当天数为0 js自动处理为上一月的最后一天
  return thisDate.getDate()
},
dateTranslator(value) {
  const date = new Date(value)
  const y = date.getFullYear()
  const m = (date.getMonth() + 1).toString().padStart(2, '0')
  const d = date.getDate().toString().padStart(2, '0')
  return `${y}-${m}-${d}`
},
dateFormatter(time) {
  if (!time) {
    return
  }
  var d = new Date(time)
  var year = d.getFullYear()
  var month = d.getMonth() + 1
  var day = d.getDate()
  var hours = d.getHours()
  var min = d.getMinutes()
  var seconds = d.getSeconds()

  if (month < 10) month = '0' + month
  if (day < 10) day = '0' + day
  if (hours < 0) hours = '0' + hours
  if (min < 10) min = '0' + min
  if (seconds < 10) seconds = '0' + seconds
  return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds)
},
getContractStatusList(flag) {
  if (flag === 'sale') {
    return [{ id: 1, name: '已签订' },
    { id: 2, name: '执行中' },
    { id: 3, name: '已完成' },
    { id: 4, name: '已解除' },
    { id: 5, name: '已中止' },
    { id: 6, name: '已归档' }]
  } else if (flag === 'potential') {
    return [
      { id: 7, name: '洽谈中' }, { id: 8, name: '中止' }, { id: 9, name: '终止' }, { id: 10, name: '已转正' }
    ]
  }
},
// 列表页查询数据的时候，筛选不为空的参数
checkQueryInfoHandler(obj) {
  let payload = {}
  for (let k in obj) {
    if (obj[k]) {
      payload[k] = obj[k]
    }
  }
  return payload
},
hrefParamsHandler(obj) {
  let str = ''
  for (let k in obj) {
    if (obj[k]) {
      console.log(obj[k], k, '这里是什么')
      str = str + `${k}=${obj[k]}&`
    }
  }
  if (str) {
    str = str.substring(0, str.lastIndexOf('&'))
  }
  return str
}
  //   let str = ''
  //     for (let k in obj) {
  //       str = str + `${k}=${obj[k]}&`
  //     }
  //      str=str.substring(0, str.lastIndexOf('&'))
  // }
}



// WEBPACK FOOTER //
// ./src/util/util.js